<template>
  <div class="ovop-map">
    <div class="left">
      <div class="controls" v-show="mapType === 'china'">
        <DataSourceSelect
          :list="menus"
          @change="onDataSourceChange"
          ref="select"
        />
      </div>
      <div class="controls border-bottom" v-show="mapType === 'province'">
        <el-row type="flex" justify="space-between">
          <el-col :span="2">
            <img src="@/assets/返回.png" @click="onBack" />
          </el-col>
          <el-col :span="13">
            <ProvinceDataSourceDashboard :explore="explore" :active="active"  @checkTab="onCheckTab"/>
          </el-col>
          <el-col :span="4"></el-col>
          <el-col :span="8">
            <el-select
              class="city-select"
              v-model="city"
              @change="onSelectChange"
            >
              <el-option
                v-for="item in cityArray"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <div class="map">
        <ECharts :options="options" @click="onClick" />
      </div>
    </div>
    <div class="right">
      <OvopList :title="title" :ovopArray="ovopArray" />
    </div>
  </div>
</template>

<script>
import DataSourceSelect from '@/components/ovop/ChinaDataSourceSelect'
import ProvinceDataSourceDashboard from '@/components/ovop/ProvinceDataSourceDashboard'
import OvopList from '@/components/OvopRanking'
import ECharts from 'vue-echarts'

import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/scatter'
import 'echarts/map/js/china'
import 'echarts/map/js/province/anhui'
import 'echarts/map/js/province/aomen'
import 'echarts/map/js/province/beijing'
import 'echarts/map/js/province/chongqing'
import 'echarts/map/js/province/fujian'
import 'echarts/map/js/province/gansu'
import 'echarts/map/js/province/guangdong'
import 'echarts/map/js/province/guangxi'
import 'echarts/map/js/province/guizhou'
import 'echarts/map/js/province/hainan'
import 'echarts/map/js/province/hebei'
import 'echarts/map/js/province/heilongjiang'
import 'echarts/map/js/province/henan'
import 'echarts/map/js/province/hubei'
import 'echarts/map/js/province/hunan'
import 'echarts/map/js/province/jiangsu'
import 'echarts/map/js/province/jiangxi'
import 'echarts/map/js/province/jilin'
import 'echarts/map/js/province/liaoning'
import 'echarts/map/js/province/neimenggu'
import 'echarts/map/js/province/ningxia'
import 'echarts/map/js/province/qinghai'
import 'echarts/map/js/province/shandong'
import 'echarts/map/js/province/shanghai'
import 'echarts/map/js/province/shanxi'
import 'echarts/map/js/province/shanxi1'
import 'echarts/map/js/province/sichuan'
import 'echarts/map/js/province/taiwan'
import 'echarts/map/js/province/tianjin'
import 'echarts/map/js/province/xianggang'
import 'echarts/map/js/province/xinjiang'
import 'echarts/map/js/province/xizang'
import 'echarts/map/js/province/yunnan'
import 'echarts/map/js/province/zhejiang'

/**
 * 省份简称全称映射表
 * @type {*[]}
 */
const provinceArray = [
  {
    name: '安徽',
    fullName: '安徽省'
  },
  {
    name: '澳门',
    fullName: '澳门特别行政区'
  },
  {
    name: '北京',
    fullName: '北京市'
  },
  {
    name: '重庆',
    fullName: '重庆市'
  },
  {
    name: '福建',
    fullName: '福建省'
  },
  {
    name: '甘肃',
    fullName: '甘肃省'
  },
  {
    name: '广东',
    fullName: '广东省'
  },
  {
    name: '广西',
    fullName: '广西省'
  },
  {
    name: '贵州',
    fullName: '贵州省'
  },
  {
    name: '海南',
    fullName: '海南省'
  },
  {
    name: '河北',
    fullName: '河北省'
  },
  {
    name: '黑龙江',
    fullName: '黑龙江省'
  },
  {
    name: '河南',
    fullName: '河南省'
  },
  {
    name: '湖北',
    fullName: '湖北省'
  },
  {
    name: '湖南',
    fullName: '湖南省'
  },
  {
    name: '江苏',
    fullName: '江苏省'
  },
  {
    name: '江西',
    fullName: '江西省'
  },
  {
    name: '吉林',
    fullName: '吉林省'
  },
  {
    name: '辽宁',
    fullName: '辽宁省'
  },
  {
    name: '内蒙古',
    fullName: '内蒙古自治区'
  },
  {
    name: '宁夏',
    fullName: '宁夏回族自治区'
  },
  {
    name: '青海',
    fullName: '青海省'
  },
  {
    name: '山东',
    fullName: '山东省'
  },
  {
    name: '上海',
    fullName: '上海市'
  },
  {
    name: '山西',
    fullName: '山西省'
  },
  {
    name: '陕西',
    fullName: '陕西省'
  },
  {
    name: '四川',
    fullName: '四川省'
  },
  {
    name: '台湾',
    fullName: '台湾省'
  },
  {
    name: '天津',
    fullName: '天津市'
  },
  {
    name: '香港',
    fullName: '香港特别行政区'
  },
  {
    name: '新疆',
    fullName: '新疆维吾尔自治区'
  },
  {
    name: '西藏',
    fullName: '西藏自治区'
  },
  {
    name: '云南',
    fullName: '云南省'
  },
  {
    name: '浙江',
    fullName: '浙江省'
  }
]

const SELECT_TYPE = {
  CITY: 'CITY',
  AREA: 'AREA'
}
export default {
  name: 'OvopMap',
  components: {
    DataSourceSelect,
    ProvinceDataSourceDashboard,
    OvopList,
    ECharts
  },
  data() {
    return {
      mapType: 'china',
      menus: [
        {
          name: '寻源商品',
          active: true
        },
        {
          name: '引入商品',
          active: false
        },
        {
          name: '地标商品',
          active: false
        }
      ],
      active: '寻源商品',
      explore: {
        onlineCount: 0,
        importCount: 0,
        iconicCount: 0
      },
      province: '',
      placeProvince: '',
      city: '',
        checkCity:'',
      placeCity: '',
      cityArray: [],
      options: {
        geo: {
          map: 'china'
        },
        tooltip:{
            formatter:(params) => `${params.name} : ${params.value || '--'}`
          },
        visualMap: {
          show: false,
          min: 0,
          max: 100,
          inRange: {
            color: [
              '#EDFFF3',
              '#D1FFF2',
              '#C1FFFE',
              '#9EE6FF',
              '#7FC0FC',
              '#547AE3'
            ]
          }
        },
        series: [
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            data: [],
            symbol: 'image:///images/坐标.png',
            symbolSize: [18, 22],
            symbolOffset: ['-50%', '-50%'],
            tooltip:{
                formatter:() => ''
            }
          },
          {
            type: 'map',
            map: 'china',
            label: {
              show: true,
              color: '#999',
              fontSize: 10.5
            },

            itemStyle: {
              areaColor: '#F6F6F6',
              borderColor: '#ccc'
              // normal: {
              //         areaColor: '#F6F6F6',
              //         borderColor: '#ccc'
              //     },
              //     emphasis: {//鼠标移入高亮显颜色
              //         areaColor: '#f46d43'
              //     }
            },
            data: []
          }
        ]
      },
      title: '全国(寻源商品)',
      ovopArray: [],
      list: [],
      selectType: SELECT_TYPE.CITY,
      placeArea: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      const response = await this.ajax.doPost({
        packageName: 'ovop',
        className: 'oneVillageOneProduct',
        methodName: 'query',
        params: {}
      })

      console.log(response)

      this.list = response

      this.drawChina()
    },
    drawChina() {
      this.selectType = SELECT_TYPE.CITY
      const data = this.list.filter((e) => {
        let result = false
        switch (this.active) {
          case '寻源商品':
            result = true
            break
          case '引入商品':
            if (e.importStatus === '已引入') {
              result = true
            }
            break
          case '地标商品':
            if (e.iconic) {
              result = true
            }
            break
          default:
            result = true
        }
        return result
      })
      this.ovopArray = data
      this.options.geo.map = 'china'
      this.options.visualMap.max = 100
      this.options.series[0].data = this.util
        .groupBy(data, (e) => e.placeProvince)
        .map((list) => {
          return {
            name: this.getName(list[0].placeProvince),
            value: this.getCp('china', this.getName(list[0].placeProvince))
          }
        })
      this.options.series[1].map = 'china'
      this.options.series[1].data = this.util
        .groupBy(data, (e) => e.placeProvince)
        .map((list) => {
          return {
            name: this.getName(list[0].placeProvince),
            value: list.length
          }
        })
    },

    drawProvince() {
      const data = this.list
        .filter((e) => {
          let result = false
          switch (this.active) {
            case '寻源商品':
              result = true
              break
            case '引入商品':
              if (e.importStatus === '已引入') {
                result = true
              }
              break
            case '地标商品':
              if (e.iconic) {
                result = true
              }
              break
            default:
              result = true
          }
          return result
        })
        .filter((e) => e.placeProvince === this.getFullName(this.province))

      this.calcExplore(
        this.list.filter(
          (e) => e.placeProvince === this.getFullName(this.province)
        )
      )

      const proviceData = this.util.groupBy(
        data.filter((e) => e.placeCity),
        (e) => e.placeCity
      )
      // console.log(Array.from(proviceData))
      // const totalLength = Array.from(proviceData).reduce((a, b) => {
      //   return a + b.length
      // },0)

      this.cityArray = [
        {
          label: `${this.getFullName(this.province)}（${data.length}）`,
          value: ''
        },
        ...proviceData.map((list) => {
          return {
            label: `${list[0].placeCity}（${list.length}）`,
            value: `${list[0].placeCity}`
          }
        })
      ]

      this.ovopArray = data
      this.options.visualMap.max = 15
      this.options.geo.map = this.province
      this.options.series[0].data = this.util
        .groupBy(data, (e) => e.placeCity)
        .map((list) => {
          return {
            name: list[0].placeCity,
            value: this.getCp(this.province, list[0].placeCity)
          }
        })
      this.options.series[1].map = this.province
      this.options.series[1].data = this.util
        .groupBy(data, (e) => e.placeCity)
        .map((list) => {
          return {
            name: list[0].placeCity,
            value: list.length
          }
        })
    },
    selectDataSource(e) {
      this.$refs['select'].click(e)
    },
    onDataSourceChange(e) {
      this.active = e.name
      this.mapType = 'china'
      this.drawChina()
      this.title = `全国(${this.active})`
    },
    onBack() {
      this.mapType = 'china'
      this.drawChina()
      this.title = `全国(${this.active})`
        this.menus = this.menus.map(item=>({...item,active:item.name === this.active}))
        console.log(this.menus)
    },
    // 计算区下边的商品
    onAreaChange(e) {
      this.placeArea = e
      this.ovopArray = this.list
        .filter(this.filterDataSource)
        .filter(
          (e) =>
            e.placeProvince === this.placeProvince &&
            e.placeCity === this.placeCity &&
            e.placeArea === this.placeArea
        )
      // .filter((e) => e.placeCity === this.placeCity)
      this.title = `${this.placeArea}(${this.active})`
      this.calcExplore(
        this.list.filter(
          (e) =>
            this.placeProvince &&
            e.placeCity === this.placeCity &&
            e.placeArea === this.placeArea
        )
      )
    },
    selectMapCity(e) {
      const city = e
      const data = this.options.series[1].data
      let haveSelect = false
      this.options.series[1].data = data.map((t) => {
        let selected = false
        if (t.name === city) {
          selected = true
          haveSelect = true
        }
        return { ...t, selected }
      })

      if (!haveSelect) {
        this.options.series[1].data.push({
          name: city,
          // value: 0,
          selected: true
        })
      }
    },
    onSelectChange(e) {
      if (this.selectType === SELECT_TYPE.CITY) {
        // 当前为省市 选择
        this.onCityChange(e)
      } else {
        // 当前为市县选择
        if (e) {
          // 县选择
          this.onAreaChange(e)
        } else {
          this.title = `${this.placeCity}(${this.active})`
          // 市选择   第一项
          const data = this.list
            .filter(this.filterDataSource)
            .filter(
              (e) =>
                e.placeProvince === this.placeProvince &&
                e.placeCity === this.placeCity
            )

          this.calcExplore(
            this.list.filter(
              (e) =>
                e.placeProvince === this.placeProvince &&
                e.placeCity === this.placeCity
            )
          )
          this.ovopArray = data
        }
        // 当前为县选择  切换不同县的数据
        // this.onAreaChange()
      }
    },
    // 组合市和下边县的数据    当点击地图市或者select切换不同市的时候
    concatAreaData(e) {
      this.selectMapCity(e)
      this.title = `${e}(${this.active})`
      this.placeCity = e
      const data = this.list
        .filter(this.filterDataSource)
        .filter(
          (e) =>
            e.placeProvince === this.placeProvince &&
            e.placeCity === this.placeCity
        )

      this.calcExplore(
        this.list.filter(
          (e) =>
            e.placeProvince === this.placeProvince &&
            e.placeCity === this.placeCity
        )
      )
      this.city = `${e}（${data.length}）`

      this.ovopArray = data

      const areaData = this.util.groupBy(
        data.filter((e) => e.placeArea),
        (e) => e.placeArea
      )
      this.cityArray = [
        {
          label: `${this.placeCity}（${data.length}）`,
          value: ''
        },
        ...areaData.map((list) => {
          return {
            label: `${list[0].placeArea}（${list.length}）`,
            value: `${list[0].placeArea}`
          }
        })
      ]
    },
    onCityChange(e) {
      if (e) {
        // 当前为省市级选择   转为市县选择
        this.selectType = SELECT_TYPE.AREA
        this.concatAreaData(e)

        // // 选择市
        // this.placeCity = e
        // this.ovopArray = this.list
        //   .filter(this.filterDataSource)
        //   .filter((e) => e.placeProvince === this.placeProvince)
        //   .filter((e) => e.placeCity === this.placeCity)

        // this.title = `${this.placeCity}(${this.active})`

        // this.calcExplore(
        //   this.list
        //     .filter((e) => e.placeProvince === this.placeProvince)
        //     .filter((e) => e.placeCity === this.placeCity)
        // )
      } else {
        // 选择省  第一项
        this.ovopArray = this.list
          .filter(this.filterDataSource)
          .filter((e) => e.placeProvince === this.placeProvince)

        this.title = `${this.placeProvince}(${this.active})`

        this.calcExplore(
          this.list.filter((e) => e.placeProvince === this.placeProvince)
        )
      }

      // this.ovopArray = this.list.filter(e => this.placeCity)
    },
    filterDataSource(e) {
      let result = false
      switch (this.active) {
        case '寻源商品':
          result = true
          break
        case '引入商品':
          if (e.importStatus === '已引入') {
            result = true
          }
          break
        case '地标商品':
          if (e.iconic) {
            result = true
          }
          break
        default:
          result = true
      }
      return result
    },
    onClick(e) {
      if (this.mapType === 'china') {
        this.selectType = SELECT_TYPE.CITY
        // 全国地图 点击省份触发
        this.mapType = 'province'
        this.province = e.name
        this.placeProvince = this.getFullName(this.province)
        this.title = `${this.placeProvince}(${this.active})`
        this.drawProvince()
        this.city = ''
        this.placeArea=this.getFullName(e.name)
      } else {
        this.selectType = SELECT_TYPE.AREA
        // this.mapType = 'city'
        // 省地图点击   选择市
        this.checkCity = e.name
        this.concatAreaData(e.name)

        // this.onCityChange(e.name)
      }
    },
    calcExplore(data) {
      this.explore.onlineCount = data.length
      this.explore.importCount = data.filter(
        (e) => e.importStatus == '已引入'
      ).length
      this.explore.iconicCount = data.filter((e) => e.iconic).length
    },
    /**
     * 获取地图内某个地点的坐标
     * @param map
     * @param name
     * @returns {[]}
     */
    getCp(map, name) {
      const geoData = echarts.getMap(map)
      let result = []
      const data = geoData.geoJson.features.find(
        (e) => e.properties.name === name
      )
      if (data) {
        result = data.properties.cp
      }
      return result
    },
    /**
     * 根据地名全称获取简称
     * @param fullName
     * @returns {*}
     */
    getName(fullName) {
      let result = fullName
      const data = provinceArray.find((e) => e.fullName === fullName)
      if (data) {
        result = data.name
      }
      return result
    },
    /**
     * 根据地名简称获取全称
     * @param name
     * @returns {*}
     */
    getFullName(name) {
      let result = name
      const data = provinceArray.find((e) => e.name === name)
      if (data) {
        result = data.fullName
      }
      return result
    },
    /**
     * 切换商品类型
     * @author Ren YuLei 2020/9/15
     */
    onCheckTab(active) {
      this.active = active
      if(this.selectType === 'CITY'){  // 所有地级市状态下的切换
          this.drawProvince()
          this.title = `${this.placeArea}(${this.active})`
      } else if(this.selectType === 'AREA'){   // 某个市状态下的切换
          this.concatAreaData(this.checkCity)
      }
    }
  }
}
</script>

<style lang="scss">
.echarts {
  width: 720px;
  height: 620px;
}

.ovop-map {
  .left {
    display: inline-block;
    width: 720px;
    height: 720px;
    margin-right: 20px;
    vertical-align: top;

    img {
      width: 30px;
      cursor: pointer;
    }

    .city-select {
      width: 230px;
      margin-top: 10px;
    }

    .controls {
      padding: 20px;
      height: 59px;
      border-bottom: 1px solid white;
    }

    .border-bottom {
      border-bottom: 1px solid #f4f4f4;
    }
  }

  .right {
    display: inline-block;
    width: 360px;
    vertical-align: top;
  }
}
</style>
